import type { PIIString } from '@trello/privacy';

import { useMemberUsernameToMemberIdQuery } from './MemberUsernameToMemberIdQuery.generated';

export const useUsernameToQueryMemberId = (username: PIIString) => {
  const { data } = useMemberUsernameToMemberIdQuery({
    waitOn: ['None'],
    skip: username === null,
    variables: {
      username,
    },
  });

  return data?.memberIdFromUsername?.id;
};
